import { render, staticRenderFns } from "./onWatp.vue?vue&type=template&id=d4be5e9a&scoped=true"
import script from "./onWatp.vue?vue&type=script&lang=js"
export * from "./onWatp.vue?vue&type=script&lang=js"
import style0 from "./onWatp.vue?vue&type=style&index=0&id=d4be5e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4be5e9a",
  null
  
)

export default component.exports